import React from 'react'
import { HotSpotCanvasProps } from './HotSpotCanvas.types'
import { Region } from 'msp-integrations'
import Image from '@atoms/Image/Image'

const HotSpotCanvas = ({
  activeIndex = 0,
  activeItem = 0,
  bgImage = '',
  imageAlt,
  content,
  headline = '',
  imageDimensions = { height: 0, width: 0 },
  itemsLength = 0,
  onItemSelect = () => {},
  regions,
  title = '',
  bgColor
}: HotSpotCanvasProps) => {
  return (
    <>
      <div className='relative'>
        <Image
          src={bgImage}
          className='relative w-full'
          width={imageDimensions.width}
          height={imageDimensions.height}
          alt={imageAlt || headline}
          forceScale
        />
        <Region
          region={regions}
          {...{ activeIndex, onBubbleSelect: onItemSelect, imageDimensions }}
        />
      </div>
      <div
        className={`hotSpotCanvasContainer ${
          bgColor === 'white' ? 'bg-white text-black' : 'bg-black text-white'
        }`}
      >
        <div className='hotSpotCanvasWrapper'>
          {headline && <h3 className='hotSpotCanvasHeadline'>{headline}</h3>}
          <div className='hotSpotCanvasBody' key={activeIndex}>
            <p className='hotSpotCanvasCounter'>
              {activeItem && (
                <span className='inline-block w-6'>{activeItem}</span>
              )}
              {activeItem && itemsLength && ' / '}
              {itemsLength && (
                <span className='inline-block w-6 text-right'>
                  {itemsLength}
                </span>
              )}
            </p>
            {title && <p className='hotSpotCanvasTitle'>{title}</p>}
            {content && <>{content}</>}
          </div>
        </div>
      </div>
    </>
  )
}

export default HotSpotCanvas
